var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vpolice-school"},[_c('div',{staticClass:"index"},[_c('PoliticalWork'),_c('StarBoutique'),_c('RecentlyReleas'),_c('LatestRelease')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }